

<template>
  <div class="full-video-page show">
    <div id="vx-video" class="full-video"></div>
    <van-icon 
      name="clear" 
      color="var(--g6)"
      class="close-icon"
      @click.stop="$router.back();"/>
  </div>
</template>

<script>
import { getXgplayer } from "@mlib/js/get-libs/index.js";

export default {
  name: 'full-video',
  data() {
    return {
      url: this.$route.query.url,
      // 是否可以展示下载按钮, 目前设定：当在微信环境且是移动端时，不展示
      enableDown: !(app.base.env == 'wx' && app.base.isMobile == true)
    };
  },
  computed: {},
  methods: {},
  created() {
  },
  async mounted() {
    // 有可能有语音正在播放中，先停止掉.
    app.module.voice.stop();

    await getXgplayer()

    let player = new Player({
      id: 'vx-video',
      url: this.url,
      autoplay: true,
      videoInit: true,
      width: '100%',
      height: '100%',

      playbackRate: [0.75, 1, 1.5, 1.75, 2, 2.5, 3],
      rotate: {
        //视频旋转按钮配置项
        innerRotate: true, //只旋转内部video
        clockwise: true, // 旋转方向是否为顺时针
      },
      //设置download控件显示
      download: this.enableDown,
    });
  },
  watch: {},
};
</script>

<!-- 全局视频播放组件 -->
<style lang="scss" scoped>
.full-video-page {
  position: absolute;
  width: 0;
  overflow: hidden;
  opacity: 0;
  z-index: -1;
  top: 0;
  left: 0;
  &.show {
    width: 100%;
    height: 100%;
    opacity: 1;
    z-index: 99;
  }
  .full-video {
    position: absolute;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.8);
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
    // @include flex-center(column);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .loading {
      width: 30px;
      height: 30px;
    }
    .loading-text {
      padding-top: 10px;
      font-size: 12px;
      color: #fff;
    }
  }
  .close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 10px;
    color: #fff;
    z-index: 2;
    .close-img {
      width: 20px;
      height: 20px;
    }
  }
  .close-icon {
    color: #fff;
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 100;
    font-size: 14px;
  }
}
</style>